import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { Item } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type PaymentMethodsProps = {
  shippingMethods: Item[] | undefined
}

export function ShippingMethods(props: PaymentMethodsProps) {
  const { formatList } = useIntl()
  const { shippingMethods } = props

  if (!shippingMethods?.length) return null

  const processTooltip = () =>
    formatList(shippingMethods.map((sm) => sm.name) ?? [])

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.shippingMethods.title} />
      </Tag>
    </Tooltip>
  )
}
